import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { map } from "rxjs";
import { ROUTE } from "../../../shared/utils/routes";
import { AuthService } from "../../services/auth/auth.service";

/**
 * Keeps a self-service signup inside the onboarding wizard until the company
 * data is there. An account created by an admin has no `profileIncomplete`
 * flag at all, so it passes straight through and nothing changes for the whole
 * install base.
 */
export const profileCompleteGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);

  return inject(AuthService)
    .getCurrentUserAndOnBehalfOfUser()
    .pipe(
      map((profile) => {
        const user = profile?.currentUser as
          | { profileIncomplete?: boolean }
          | null
          | undefined;

        if (!user?.profileIncomplete) {
          return true;
        }

        // Already on the wizard: letting it through is what makes the
        // redirection terminate.
        if (state.url.startsWith(ROUTE.ONBOARDING)) {
          return true;
        }

        return router.parseUrl(ROUTE.ONBOARDING);
      })
    );
};
